module.exports = __webpack_public_path__ + "static/media/home-mobile-2026-ita.b633968c.png";